<template>
  <div class="wrapper">
    <div class="top_contain">
      <img class="tanhao_inage" src="../../../../../assets/img/tanhao.png" alt="" />
      <div class="font_14_1890FF">
        <span class="font_14_333333">请配置当前角色在系统管理中的菜单访问权限。</span
        >如果需要进行二次授权时，需要勾选“角色管理”或“用户管理”的菜单权限，可选择的权限范围为此处配置的系统管理菜单权限。
      </div>
    </div>
    <el-tree
      ref="tree"
      class="margin_top_10"
      style="width:100%"
      :data="Data"
      node-key="id"
      show-checkbox
      default-expand-all
      @check="checkChangeMenthod"
      :default-checked-keys="selectedKeyArray"
    >
      <div class="flex_row_center_start" slot-scope="{ data }">
        <span>{{ data.name }}</span>
      </div>
    </el-tree>
  </div>
</template>

<script>
import Axios from '@/lib/axios';
import API from '@/lib/apiList';
import NewAxios from '@/lib/newEnvironmentAxios';
export default {
  props: {
    roleId: String
  },
  data() {
    return {
      Data: [],
      selectedKeyArray: []
    };
  },
  watch: {
    roleId(value) {
      if (value.length > 0) {
        this.allResourceRequest();
      }
    }
  },
  mounted() {
    this.allResourceRequest();
  },
  methods: {
    checkChangeMenthod(e) {
      let res = this.$refs.tree.getCheckedKeys();
      console.log(res);
      this.$emit('systermAuthorOneMenthod', {
        value: res
      });
    },

    /** 处理所有的资源列表 */
    dealAllResourceData(array) {
      let totalArray = [];
      let userInfoDict = {};
      let userInfoChildren = [];
      let anotheruserInfoDict = {};
      let anotheruserInfoChildren = [];
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.sysMark == '1') {
          if (element.sysCode == 'SMHT') {
            //人员信息管理
            if (element.code == '972') {
              userInfoDict = element;
            }
            //设备管理
            if (element.code == '973') {
              anotheruserInfoDict = element;
            }
          }
        }
      }
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.sysMark == '1') {
          if (element.sysCode == 'SMHT') {
            //人员信息管理
            if (element.parentCode == '972') {
              userInfoChildren.push(element);
            }
            if (element.parentCode == '973') {
              anotheruserInfoChildren.push(element);
            }
          }
        }
      }
      userInfoDict.children = userInfoChildren;
      anotheruserInfoDict.children = anotheruserInfoChildren;
      totalArray = [userInfoDict, anotheruserInfoDict];
      this.Data = totalArray;
    },

    /** 处理(指定role的角色) 返回的资源数据 */
    dealWithResourceData(toatalArray, anotherArray) {
      let tmpArray = [];
      for (let index = 0; index < toatalArray.length; index++) {
        const element = toatalArray[index];
        for (let index = 0; index < anotherArray.length; index++) {
          const anotherelement = anotherArray[index];
          if (
            element.code == anotherelement &&
            element.sysMark == '1' &&
            element.sysCode == 'SMHT'
          ) {
            tmpArray.push(element.id);
          }
        }
      }
      this.selectedKeyArray = tmpArray;
      this.$emit('systermAuthorOneMenthod', {
        value: this.selectedKeyArray
      });
    },

    /** =================================  ⬇ 网络请求相关 ⬇ ============================================ */
    /** 获取所有的资源列表 */
    allResourceRequest() {
      NewAxios.requestWWWForm({
        data: {
          ...API.searchResourcesPage,
          requestData: {
            projectId: this.$cookies.get('PROJECT_ID'),
            pageNo: 1,
            pageSize: 10000
          }
        }
      })
        .then(res => {
          if (res.data.resultStatus === 1000) {
            let paragram = JSON.parse(res.data.result).result;
            let data = paragram.result;
            this.dealAllResourceData(data);
            this.roleResouseRequest(data);
          } else {
            this.$message.error(res.data.memo);
          }
        })
        .catch(err => {
          // this.$message.error(err.message);
        });
    },

    /** 根据roleid获取菜单权限数组 */
    roleResouseRequest(totalArray) {
      NewAxios.requestWWWForm({
        data: {
          ...API.getRoloMenuAndSysTem,
          requestData: {
            projectId: this.$cookies.get('PROJECT_ID'),
            roleId: this.roleId
          }
        }
      })
        .then(res => {
          if (res.data.resultStatus === 1000) {
            let paragram = JSON.parse(res.data.result);
            this.dealWithResourceData(totalArray, paragram.smhtBack);
          } else {
            this.$message.error(res.data.memo);
          }
        })
        .catch(err => {
          // this.$message.error(err.message);
        });
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background: white;
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.top_contain {
  background: #eef7fe;
  padding-left: 17px;
  padding-right: 17px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #d5ebfd;
  margin-bottom: 19px;
}

.tanhao_inage {
  width: 18px;
  height: 18px;
}

.font_14_333333 {
  font-size: 14px;
  color: #333333;
}

.font_14_1890FF {
  font-size: 14px;
  color: #1890ff;
}
</style>
